export default "__VITE_ASSET__e73e232f__"